var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondJeu1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "444 00 2888 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_25);}.cls-2{fill:none;}.cls-3{fill:#20456e;}.cls-4{fill:#5596aa;}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_14);}.cls-6{fill:#ce5e36;}.cls-7{clip-path:url(#clip-path);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_25-3);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_25-4);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_19);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_66);}.cls-12{clip-path:url(#clip-path-2);}.cls-13{fill:#b3bcbb;}.cls-14{fill:#7b8282;}.cls-15{fill:#ced9d8;}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_117);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_117-2);}.cls-18{fill:#878e8e;}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_117-3);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_117-4);}.cls-21,.cls-22{opacity:0.35;}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_126);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_126-2);}.cls-23{fill:#234c69;opacity:0.74;}.cls-24{fill:#66926d;}.cls-25{clip-path:url(#clip-path-3);}.cls-26,.cls-32{fill:#e0e9ee;}.cls-26,.cls-27,.cls-29{stroke:#e0e9ee;stroke-miterlimit:10;stroke-width:8px;}.cls-27{fill:#afc0c6;}.cls-28,.cls-29{fill:#93a6b1;}.cls-30{fill:#384353;}.cls-31{fill:#b2c0c0;}.cls-33{fill:#1e2736;}.cls-34{clip-path:url(#clip-path-4);}.cls-35{fill:#475169;}.cls-36{clip-path:url(#clip-path-5);}.cls-37{clip-path:url(#clip-path-6);}.cls-38{fill:#c9dae2;}.cls-39{clip-path:url(#clip-path-7);}.cls-40{fill:#221e23;}.cls-41{clip-path:url(#clip-path-8);}.cls-42{fill:#141414;}.cls-43{clip-path:url(#clip-path-9);}.cls-44{clip-path:url(#clip-path-10);}.cls-45{fill:#173856;}.cls-46{fill:#97675e;}.cls-47{clip-path:url(#clip-path-11);}.cls-48{fill:url(#D\xE9grad\xE9_sans_nom_6);}.cls-49{clip-path:url(#clip-path-12);}.cls-50{fill:#fff;}.cls-51{fill:#82cec4;}.cls-52{fill:#282b2e;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_25",
    y1: 999.5,
    x2: 2419,
    y2: 999.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b8282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#a1a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#c1cccb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ced9d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_14",
    x1: 1661.31,
    y1: 1539.68,
    x2: 2001.02,
    y2: 2807.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#234c69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#305f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5191a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5596aa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(372.54 0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1 1593 2000.09 1480.22 2418.78 1063.85 2419 763 0 406 1 1593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_25-3",
    x1: 372.54,
    x2: 2791.1,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_25-4",
    x1: 1858.49,
    y1: 142,
    x2: 1858.49,
    y2: 1302.63,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_19",
    x1: 642.28,
    y1: 1798.11,
    x2: 416.66,
    y2: 2188.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5596aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#4d8a9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#2f5d78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234c69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_66",
    x1: 798.49,
    y1: 1733.3,
    x2: 798.49,
    y2: 2267.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5596aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5494a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4f8da2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#468097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#3a6e87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#2b5773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234c69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(372.54 0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 1741 1 435 134.48 453.98 259.2 1796.09 0 1741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_117",
    x1: 3131.11,
    y1: 1467.64,
    x2: 3040.83,
    y2: 732.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ced9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ced9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bfc9c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#b6bfbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3bcbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_117-2",
    x1: 2334.19,
    y1: 901.49,
    x2: 2261.98,
    y2: 313.39,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_117-3",
    x1: 1867.34,
    y1: 198.26,
    x2: 1824.5,
    y2: -150.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_117-4",
    x1: 803.62,
    y1: 331.32,
    x2: 761.84,
    y2: -8.94,
    gradientTransform: "matrix(-1, 0, 0, 1, 1286.54, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_126",
    x1: 601.98,
    y1: 180.79,
    x2: 863.29,
    y2: 134.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b8282",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#808787",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#aab4b3",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#c4cfce",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ced9d8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_126-2",
    x1: 1399.82,
    y1: 174.8,
    x2: 1615.31,
    y2: 174.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 2031.49, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_126"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(372.54 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485.6,849.84a140.78,140.78,0,0,1-1.36-14.91c0-5.76,246.73-13.56,477.19-13.56,0,0,1085.22,52.19,1186.89,75.24,71.85,25.76,124.72,59.65,139.63,69.14s321.3,237.24,418.91,343c20.33,14.91,44.73,23,44.73,23s166.75,55.58,208.77,80c16.1,9.35,28.58,17.26,39.64,26.24v699s-11.17,42.07-61.33,69.18-130.14,56.94-210.12,39.32c-25.76-8.14-51.52-29.83-51.52-29.83s-370.1,120.66-658.85,88.12c-70.5-8.13-75.92-6.78-88.12-13.56s-10.85-13.55-12.2-20.33-42-222.33-78.63-277.91-29.83-66.43-66.43-108.46c-54.23,8.14-115.23,13.56-128.79,20.34s-44.73,20.33-73.2,86.76-17.63,207.42-8.14,223.69c6.78,16.26-6.78,5.42-33.89-4.07s-751-197.93-751-197.93,2.71,80-55.58,111.17-132.86,19-132.86,19Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(372.54 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M996.68,1297.21l-6.78-292.83s-5.42-86.76,54.23-78.63c33.58,4.58,160,4.07,192.5,20.34S1529.46,1384,1529.46,1384s27.11,44.74-19,80-82.7,13.56-82.7,13.56-265.71-36.6-322.64-63.72S1004.82,1356.86,996.68,1297.21Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(372.54 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M741.82,1878.79,797.4,1811s8.13-10.85,24.4-12.21,326.72,51.52,326.72,51.52,5.42-2.71,29.82,21.69,85.41,92.19,85.41,92.19,17.62,36.6-8.14,35.24-507-103-507-103S736.39,1893.7,741.82,1878.79Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(372.54 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1899.56,1687.64l-46.1-90.83s-13.69-44.74,13.56-44.74c90.83,0,361.83,78.83,431.1,84,71.85,5.43,147.77,4.07,183,1.36s248.08-28.47,264.35-31.18S2962,1577,3000,1556v136c-84.05,46.09-235.53,75.62-235.53,75.62s-212.84,36.61-414.83,29.83c-132.86-5.42-197.93-29.83-203.35-39.32s-101.68-12.2-123.37-16.26S1934.8,1733.73,1899.56,1687.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(372.54 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1616.22,1335.17l-257.58-406.7s-8.13-12.2,0-12.2S2210,940.67,2210,940.67a59.13,59.13,0,0,1,16.27,2.71c27.11,9.49,147.77,94.9,212.84,151.83s261.64,222.33,261.64,222.33,9.49,17.63-10.84,17.63c-160-21.69-901.52,31.18-974.73,35.24C1715.18,1370.41,1644.69,1379.9,1616.22,1335.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(372.54 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M697.79,2361.41s-2.07,59.65-4.78,69.13c0,0,39.18,51.29,51.52,71.86A69.57,69.57,0,0,0,796,2536.29c20.34,2.71,65.08-2.71,69.14-19s6.78-33.89-16.27-54.23-64.84-47.09-65.07-54.23S773,2361.41,773,2361.41Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(372.54 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M777.06,2318l132.86,8.14s0-43.38-14.91-47.45c0,0-53.73-9.36-59.65-16.27-8.14-9.49-20.34-14.91-29.83-40.67s-31.18,0-31.18,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(372.54 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M630.65,1583.25s5.42,143.7,16.27,200.64,21.69,223.69,24.4,248.09,9.49,131.5,5.42,169.46,14.92,161.32,14.92,161.32,48.8,42,88.12,8.14c0-67.79-4.07-128.79,0-136.93,0,0,27.11-4.06,36.6-19,0-23-8.14-99,0-135.56,0,0,12.2-70.5,16.27-108.46,16.26-36.6,73.2-296.89,63.71-370.09C828.58,1576.47,630.65,1583.25,630.65,1583.25Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(372.54 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M724.19,1081.66c-.19-13.66-1.35-51.52-1.35-51.52s-9.49-8.13-12.2-16.27-2.72-19-2.72-19-14.91-6.77-20.33-27.11,4.07-25.76,8.13-24.4S707,947,707,947s-5.15-40.7.92-57.85,19-33.89,70.5-35.25,59.65,39.32,59.65,50.16V940a16,16,0,0,1,12.2.69c6.78,3,6.78,17.62,4.07,27.11s-4.07,25.76-14.92,23.05c-1.35,14.91-1.35,16.26-4.06,24.4S824.51,1036,824.51,1036v45.69l-23,24.4L754,1103S724.39,1095.31,724.19,1081.66Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6",
    x1: 770.29,
    y1: 883.5,
    x2: 770.29,
    y2: 964.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#282b2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#634b47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#895f58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97675e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12",
    transform: "translate(372.54 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M624.55,1402.27,640.82,1489l-16.27,89.48s85.41,50.16,185.73,44.74,96.25-17.63,96.25-17.63l-14.91-134.21,39.31,105.74s40.67,6.78,81.34-19c0,0-61-208.77-63.71-257.57S938,1163,938,1163s-4.46-28-37-47a276.8,276.8,0,0,0-65-27s7-8,3-17c-1.28-2.89,1-10-14-13,0,7-1,18-5,23-7,6-21,14-37,21-21.61.53-45.74-14.16-56-21-2-3-3-10-3.36-24.12-4.55,1.06-7.93,2.41-9.64,4.12-6,6-9,17-6,22-41,8-82,31-82,31s-40.22,15.46-47,48-67,186.4-64.26,228.43,52.87,55.58,56.94,46.09S624.55,1402.27,624.55,1402.27Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fond d&amp;apos;\xE9cran jeu 1 r\xE9vision") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 373.54,
    y: 1,
    width: 2999,
    height: 2999
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4",
    "data-name": "Calque 4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "372.54 2201 372.54 1885 372.54 1741 631.74 1792.03 932.96 1733.3 3315.46 1402.95 3372.54 1411 3372.54 2377 1282.54 3000 372.54 2999 372.54 2201"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "372.54 2999 372.54 1885 2445.62 1527.67 3372.54 1657 3371.54 2363 1282.54 3000 372.54 2999"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "3372.54 2348 2242.12 2700.05 966.59 2243.46 828.31 2288.2 2086.39 2748.62 1282.54 3000 1746.54 3001 3372.54 2462 3372.54 2348"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "373.54 1593 2372.64 1480.22 2791.32 1063.85 2791.54 763 372.54 406 373.54 1593"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "373.54 1593 2372.42 1480.22 2791.1 1063.85 2791.1 772.56 372.54 406 373.54 1593"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "372.54 1263 3344.43 1302.63 3207.51 387.56 372.54 142 372.54 1263"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "673.77 2267.86 631.74 1792.03 372.54 1741 373.54 2164 673.77 2267.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "965.24 2186.53 932.96 1733.3 631.74 1792.03 673.77 2267.86 965.24 2186.53"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "151.84 1698.48 51.52 387.56 507.02 453.98 631.74 1798.8 151.84 1698.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "507.02 453.98 31.18 712.91 0 369.93 507.02 453.98"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "507.02 453.98 828.31 498.72 932.96 1733.3 631.74 1792.03 507.02 453.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "2791.54 763 2791.54 1403 3372.54 1438 3372.54 733 2791.54 763"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1157.54 449 3372.54 774 3372.19 224.69 1157.54 449"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "3372.54 841 373.54 435 372.54 296 631.74 349.6 3097.54 1 3372.54 1 3372.54 248 1157.74 448.56 3372.54 774 3372.54 841"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "631.54 350 597.54 0 3097.54 1 631.54 350"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "631.74 349.6 597.54 0 372.54 0 372.54 296 631.74 349.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "631.74 349.6 597.54 0 839.54 0 847.23 319.12 631.74 349.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "631.68 349.6 597.54 0 424.54 1 416.19 304.86 631.68 349.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M640.14,2107.38c4.07,1.16,970.87,264.22,1306.29,262.15s933.34-131.89,938.73-188.28-1470.93-302.46-1470.93-302.46l-821.54,89.8S636.07,2106.21,640.14,2107.38Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "1746.54 3001 3372.54 2462.89 3371.54 2999 1746.54 3001"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3",
    "data-name": "Calque 3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M484.24,860.68s-4.07-29.82,0-33.89,141.67-15.59,622.93-31.86c0,0,939.48,78.63,1041.15,101.68,71.85,25.76,124.72,59.65,139.63,69.14s321.3,237.24,418.91,343c20.33,14.91,44.73,23,44.73,23s166.75,55.58,208.77,80c16.45,9.55,28.44,17,39.64,26.24,0,41,1,699,1,699s-12.2,42-62.36,69.14-130.14,56.94-210.12,39.32c-25.76-8.14-51.52-29.83-51.52-29.83s-370.1,120.66-658.85,88.12c-70.5-8.13-75.92-6.78-88.12-13.56s-10.85-13.55-12.2-20.33-42-222.33-78.63-277.91-29.83-66.43-66.43-108.46c-54.23,8.14-115.23,13.56-128.79,20.34s-44.73,20.33-73.2,86.76-17.63,207.42-8.14,223.69c6.78,16.26-6.78,5.42-33.89-4.07s-751-197.93-751-197.93,2.71,80-55.58,111.17-132.86,19-132.86,19Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M541.18,1732.67,472,866.39S607.61,861,640.14,861c34,0,334.48-2.55,414.84,0,85.4,2.71,122,8.14,162.68,27.11S1280,943.67,1280,943.67s470.41,688.68,501.59,732.06S1872.44,1772,1928,1785.54s267.07,36.6,267.07,36.6,375.52,35.25,631.74-31.18c78.78-20.42,132.41-35.17,173.17-48v136c-495.26,156.94-1580.42,500.32-1589.84,500.32-12.2,0-1249.92-353.83-1220.1-359.25S541.18,1732.67,541.18,1732.67Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M550.67,1638.84s32.53,44.73,35.24,50.16a79.31,79.31,0,0,1,4.07,9.48H550.67Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1551.15,2224.48s-39.32-104.38-39.32-204.7,8.14-149.13,8.14-149.13,8.13-54.22,75.92-61c57-5.71,120.65,25.76,120.65,25.76s32.54,19,40.67,32.53,8.78,16.69,8.78,16.69l-197.22,362.9Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M550.67,1698.48H590s55.58,111.17,71.85,180.31,16.27,63.71,17.63,69.14,6.77,20.33,23,32.53c10.85,8.14,75.92,32.54,75.92,32.54l12.2,31.18s-47.45,99-50.16,100.32-204.7,13.56-204.7,13.56Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M565,1798.78s48,35.27,50.7,116.61-16.27,136.92-32.54,143.7C568.13,2065.37,565,1798.78,565,1798.78Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M510,1066.08c2.71-4.23,33.89-101.44,65.07-121.16s348.41-.64,348.41-.64,10.84,2.82,12.2-8.45S922.12,926,922.12,926l-314.51-9.23s-31.19,1.41-46.1,14.09-43.38,67.63-59.65,115.53S510,1066.08,510,1066.08Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M337.52,1171.74c3.69,4.22,46.1,101.43,88.51,121.16s464.19,39.67,478.11,39.95c19.34.28,15.27,1.69,16.59,8.45,1.85,11.27-18.44,9.87-18.44,9.87l-432-30.09s-42.41-1.41-62.7-14.09-59-67.63-81.13-115.53S337.52,1171.74,337.52,1171.74Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1545.93,2223.13s-35.88-112.72-38.37-175-8.12-153.09,7.38-181.56,24-66.43,105.65-63.72c60.64,2,107.2,28.83,131.2,50.16,12.2,10.85,14.91,21.69,17.62,25.76,9.57,14.36,13.51,17.62,14.91,35.25,1.3,16.27-213,324-213,324Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1812.33,1945.44s43.84-58.52,58.76-72.07,32.53-46.1,104.38-31.18,197.93,25.75,264.36,29.82,207.41,20.34,404-8.13c136.18-19.73,276.28-49.86,356.71-70.57C3000,1857,3000,2346,3000,2346l-1335,46.59Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 2496.46,
    cy: 2020.82,
    rx: 29.15,
    ry: 31.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2649.14,2224.2s338-81.42,364.28-91.41-84.91,164.9-84.91,164.9l-269.78-12.2Z",
    transform: "translate(372.54 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1015.66,1527.67s-12.2-1.35-17.62-12.2a30.34,30.34,0,0,1-2.71-20.34l-24.41-4.06s-9.49-2.71-9.49-10.85,10.85-9.49,10.85-9.49l24.4-2.71s2.71-17.62,12.2-17.62,16.27,0,20.34,2.71,6.78,21.69,6.78,21.69l16.26,2.71s10.85,1.36,10.85,12.2-5.42,13.56-12.2,13.56h-13.56s0,8.13-1.35,13.56S1025.15,1527.67,1015.66,1527.67Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M996.68,1297.21l-6.78-292.83s6.78-62.36,54.23-78.63c32.06-11,160,4.07,192.5,20.34S1529.46,1384,1529.46,1384s27.11,44.74-19,80-82.7,13.56-82.7,13.56-265.71-36.6-322.64-63.72S1017,1375.84,996.68,1297.21Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1437.27,1264.67s-167.59-278.84-183-284.69c-42-15.92-107.1-27.11-202-25.76-13.55,5.43-17.62,5.43-21.69,36.61s-1.71,275.48,5.43,296.89c6.77,20.33,19,40,47.89,62.28,39.61,30.48,236.32,66.12,260.06,56.89,36.57-14.22,74.34-104.26,70.28-139.51s-2.71-70.49-12.2-99,202,283.33,202,283.33l-196.57,61L928.9,1388l32.53-336.21s56.94-165.39,59.65-166.75,193.86,0,193.86,0l272.49,404Z",
    transform: "translate(372.54 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M741.82,1878.79,797.4,1811s8.13-10.85,24.4-12.21,326.72,51.52,326.72,51.52,5.42-2.71,29.82,21.69,85.41,92.19,85.41,92.19,17.62,36.6-8.14,35.24-507-103-507-103S736.39,1893.7,741.82,1878.79Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M768.93,1815.07s352.47,54.23,372.81,59.65,99,100.32,105.74,103,19,4.07,28.47-4.06-50.16-141-52.87-141-298.25-81.34-301-82.7S773,1766.27,773,1766.27Z",
    transform: "translate(372.54 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1899.56,1687.64l-46.1-90.83s-13.69-44.74,13.56-44.74c90.83,0,361.83,78.83,431.1,84,71.85,5.43,147.77,4.07,183,1.36s248.08-28.47,264.35-31.18,225-29.83,263-54.23,31.18-40.67,31.18-46.09-1.35-13.56-4.07-25.76c1.36,1.36,5.43,9.49,5.43,9.49s1.35,4.07,2.71,5.42c.32.33,6.78,9.49,12.2,17.63,3.68,6.62,11.95,31.09,14.91,47.45,1.36,6.78,0,20.33,0,20.33s9.49,66.43-74.56,112.52-231.82,74.56-231.82,74.56-212.84,36.61-414.83,29.83c-132.86-5.42-197.93-29.83-203.35-39.32s-101.68-12.2-123.37-16.26S1934.8,1733.73,1899.56,1687.64Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2344.21,1800.16s27.12-14.91,32.54-20.34,6.78-19,2.71-36.6-6.78-40.67-35.25-74.56L2306.26,1628l695.45-82.7h10.85s4.07,14.92,4.07,23-8.79,52.18-8.14,89.47c.51,29.19-10.48,38.29-24.4,52.88-10.59,11.09-184.37,59.65-249.44,73.2s-379.59,28.47-379.59,28.47Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2788.06,1666.85c-4.09-2-12.28,0-12.28,0s4.1-8.18,6.14-10.23,4.1,0,6.14,0,2.05-4.1,2.05-6.14-6.14-2-10.23,0-8.94,7.64-10.24,10.23c-2,4.1-8.18,2-8.18,2v-6.14h4.09a9,9,0,0,0,2-6.14c-8.19,0-6.14-6.14-6.14-6.14s6.14,2,10.23,0,2-6.14,2-6.14h-8.19s-3.74-4.79-11.92-4.79-14.23,6-16.27,16.27c0-2-8.11-5.45-12.2-1.35s-1.21,11.66-5.3,13.71-8.19,12.28,2,8.19,4.1-16.38,8.19-16.38a6.46,6.46,0,0,1,6.8,6.86c0,4.1-8.33,15.34-10.38,25.57s12.43,15.37,12.43,15.37l-12.28,28.65,6.14,6.14,19.47-2.71s.69-4.73-1.36-6.78-12,1.31-12,1.31l-2.05-4.1s10.24-4.09,12.29-8.18,8.18-12.29,8.18-12.29a13.43,13.43,0,0,1,8.19,4.12c3.19,3.29,5.7,6.94,6.14,10.24.38,2.87-2.49,6.86-.44,8.9s19.86-1.79,21.69-2.71c0-4.06,1.38-4.73-2.71-6.78s-10.85,1.36-10.85,1.36.5-4.86.5-13-12.28-16.4-12.28-16.4v-12.28s14.32-2,16.37-2,2.05,0,4.09,2,6.15,2,8.19-2S2792.16,1668.9,2788.06,1666.85ZM2741,1693.46s-10.93-2.74-8.88-6.83,4.78-17.73,8.88-17.73c4.09,2,8.19,6.14,8.19,10.23S2745.08,1691.41,2741,1693.46Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 2611.01,
    cy: 1714.75,
    rx: 50.16,
    ry: 61.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1924,1668.66s-32.54-70.49-31.18-78.63,14.91-6.78,14.91-6.78l145.06,32.54s17.62,5.42,20.33,23S2088,1708,2088,1708s6.78,23-24.4,23-86.76-19-101.67-24.4S1928,1676.79,1924,1668.66Z",
    transform: "translate(372.54 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M914,1333.13c19-44.08,6.77-391.39,6.77-391.39S914,927.88,924.83,926s13.56,9.86,13.56,9.86,0,391.66-6.78,398.71c-6.78,14.08-16.27,15.49-19,15.49C895,1348.62,874.67,1335.94,914,1333.13Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2082.57,2063.16s-12.2-51.52-8.13-61,17.62-23,35.24-24.4,116.59,13.56,132.86,13.56,31.18,6.78,40.67,25.76,21.69,39.31,21.69,46.09-1.36,19-23.05,19H2104.26S2085.28,2076.72,2082.57,2063.16Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2426.91,2187.88l-6.78-75.92s-6.78-25.75,33.89-29.82,275.2-35.25,336.21-52.87c38.28-11.06,136.33-42.4,209.77-66.89v136c-63.21,19.2-151.46,45.7-189.44,55.61-62.36,16.27-303.67,65.07-336.2,65.07S2436.4,2205.5,2426.91,2187.88Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1616.22,1335.17l-257.58-406.7s-8.13-12.2,0-12.2S2210,940.67,2210,940.67a59.13,59.13,0,0,1,16.27,2.71c27.11,9.49,147.77,94.9,212.84,151.83s261.64,222.33,261.64,222.33,9.49,17.63-10.84,17.63c-160-21.69-901.52,31.18-974.73,35.24C1715.18,1370.41,1644.69,1379.9,1616.22,1335.17Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1621.64,1320.25S1379,950.16,1379,936.6s23-10.85,23-10.85,791.71,23,813.4,23,59.65,32.54,59.65,32.54,290.11,221,356.54,294.18c0,0,12.2,10.84,0,10.84s-356.54,10.85-412.13,10.85S1661,1323,1643.33,1327,1621.64,1320.25,1621.64,1320.25Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "2531.03 1363.63 1939.96 883.73 2131.11 916.26 2667.95 1363.63 2531.03 1363.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M2478.59,1333.23l58-19.38s-3.49-11.57,8.56-13.79,27.32-7.41,27.32-7.41l8,10.33s43.24-20.59,48.87-16.9-1.72,20.8-1.72,20.8l-65.61,22-9.77,10.47Z",
    transform: "translate(372.54 0)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_10",
    "data-name": "Calque 10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M697.79,2364.12s-2.07,59.65-4.78,69.14c0,0,39.18,51.28,51.52,71.85A69.57,69.57,0,0,0,796,2539c20.34,2.71,65.08-2.71,69.14-19s6.78-33.89-16.27-54.23-64.84-47.08-65.07-54.22S773,2364.12,773,2364.12Z",
    transform: "translate(372.54 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M777.06,2318l132.86,8.14s0-43.38-14.91-47.45c0,0-53.73-9.36-59.65-16.27-8.14-9.49-20.34-14.91-29.83-40.67s-31.18,0-31.18,0Z",
    transform: "translate(372.54 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M630.65,1583.25s5.42,143.7,16.27,200.64,21.69,223.69,24.4,248.09,9.49,131.5,5.42,169.46,14.92,161.32,14.92,161.32,48.8,42,88.12,8.14c0-67.79-4.07-128.79,0-136.93,0,0,27.11-4.06,36.6-19,0-23-8.14-99,0-135.56,0,0,12.2-70.5,16.27-108.46,16.26-36.6,73.2-296.89,63.71-370.09C828.58,1576.47,630.65,1583.25,630.65,1583.25Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M632,1581.9s5.42,143.7,16.27,200.64,21.69,223.68,24.4,248.08,9.49,131.5,5.42,169.46S693,2361.41,693,2361.41s48.81,42,88.12,8.13c0-67.78-4.07-128.79,0-136.92,0,0,27.11-4.07,36.6-19,0-23-8.13-99,0-135.57,0,0,12.2-70.49,16.27-108.45,16.27-36.6,73.21-296.89,63.72-370.1C829.93,1575.12,632,1581.9,632,1581.9Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M663.19,2017.07s19,29.82,71.85,24.4,58.29-36.6,58.29-36.6l9.49-271.14h19l-8.13,223.69s10.84,8.13,19,5.42c0,20.33-13.56,104.39-13.56,104.39s-13.56,10.84-28.47,6.77c-4.07,39.32-4.07,54.23-4.07,54.23s-42.89,58.34-112.52,9.49C659.12,2091.63,663.19,2017.07,663.19,2017.07Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M763.51,1614.43s-31.18,27.12-71.85,25.76-44.89-56.31-44.89-56.31Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M853,1617.14s17.62,28.47,33.89,28.47,21.69-21.69,21.69-21.69-14.91-44.73-17.62-40.67S853,1617.14,853,1617.14Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M780,2234l13.71-239.84L803,1733s24-63,25-83,0-27.85,0-27.85L918,1604l-76,630-45,22Z",
    transform: "translate(372.54 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1004.82,1556.14s24.4,58.29,25.75,67.78,13.56,80,9.49,88.12-12.2,0-12.2,0-1.35,9.49-8.13,10.85-10.85-9.49-10.85-9.49-10.84,5.42-16.27-4.07c-6.77,2.71-16.26-4.07-16.26-8.13s-12.2-55.59-12.2-55.59-4.07-6.77-5.43-12.2l-16.26-65.07Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M724.19,1081.66l-1.35-51.52s-9.49-8.13-12.2-16.27-2.72-19-2.72-19-14.91-6.77-20.33-27.11,4.07-25.76,8.13-24.4S707,947,707,947s-5.15-40.7.92-57.85,19-33.89,70.5-35.25,59.65,39.32,59.65,50.16V940a16,16,0,0,1,12.2.69c6.78,3,6.78,17.62,4.07,27.11s-4.07,25.76-14.92,23.05c-1.35,14.91-1.35,16.26-4.06,24.4S824.51,1036,824.51,1036v45.69l-23,24.4-58.3-4.07Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M707,947s4,4,5,13,3-29,3-29,4-3,4-17,15-15,15-15,38-2,46-2,34-2,39,0,2,19.55,6,26.78,6,5.22,7,7.22,0,27,0,27,4-17,6-18c0-1,2-23,2-37,0-5-5-16.07-7.52-20.53s-122.55,1.69-122.55,1.69S701.87,892.44,701,900s-.18,17.66,0,24",
    transform: "translate(372.54 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M724.19,1081.66s46.1,55.58,67.79,116.58c16.26-51.51,32.53-116.58,32.53-116.58s-16.29,20.54-46.09,21.69C743.17,1104.7,724.19,1081.66,724.19,1081.66Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M624.55,1402.27,640.82,1489l-16.27,89.48s85.41,50.16,185.73,44.74,96.25-17.63,96.25-17.63l-14.91-134.21,39.31,105.74s40.67,6.78,81.34-19c0,0-61-208.77-63.71-257.57s-10.17-137.16-10.17-137.16-4.75-28.23-37.28-47.21-44.74-25.76-44.74-25.76,1.36-13.56,19-21.69-40.67-32.54-56.94-33.89-112.52-2.72-145,23c-12.21,13.56,21.22,10.87,26.64,23.07-43.38,0-75.45,28.45-75.45,28.45s-39.31,27.11-46.09,59.65S512,1349.4,514.74,1391.43s52.87,55.58,56.94,46.09S624.55,1402.27,624.55,1402.27Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M891,1471s-5.36-164.19,0-174c5.26-9.63,10-31,14-75,0,0,26-73.37,16-90s36,37,36,37,75,407,72,407-114,6-114,6Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M668.11,1243.4S664,1241,661,1243c-1,1-43,47-43,47l25-59s5.53-84-41.73-101S493,1436,493,1436s83,25,88,25,44-58,44-58,79-109,82-114-3-12-3-12Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M708,1084s43,41,51,46c0,0,10-25,23-27,3.56-.55-52-17-55-21s-3-26-3-26l-25,5v21Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M620,1565s93,44,178,44c48,0,113-16,113-16v16l-77,34-225-50Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M782,1103s20,3,25,20c19-13,29-34,29-34l23-18-53-27,18.57,14.56S826,1075,820,1082,782,1103,782,1103Z",
    transform: "translate(372.54 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M664.54,1250.17s24.41-46,28.07-54.75,2.44-16.18,12.2-17.43,56.12,11.2,61,27.38,8.54,14.93,8.54,24.89-13.69,43.43-20.26,44.11-13.9-4.3-13.9-4.3-8.54,11.2-22,11.2h-11l-4.88,3.74S674.3,1268.83,664.54,1250.17Z",
    transform: "translate(372.54 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M705,904c-2.51-1.2-5-8-1-11-6.13-3.12-7.07-8.45-1-13-3.1-7.66.16-11.82,7-14-2-8,7-15,15-12,.69-5.71,9-7,11-6-1-2.45,9.56-5.75,11-2,3.58-3.29,7.68-4.81,13-2,4.28-1.93,8-2.16,11,.38,3.6-2.62,6.83-2.46,9.71.33,3.32-2.47,6.35-3.58,8.3.29,6.66-2.55,10.91-.41,14,4,4-1,6.25.21,7,3.25,4.83-.85,7.15.75,8,3.75,7.2-.56,10.54,2,11,7,5.61,1.46,7.61,4.32,5,9,3.66,1.27,5.32,4,4,9,1.53,4.1,1,6.88-3,7.56,3.26-1.06,6.74,6.21,2,7.44-1,.25-9,5-15,6-2-6-8-6.26-12-6-26.94,1.79-71,1-81,4-4,1-8,6-8,6Z",
    transform: "translate(372.54 0)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 372.54,
    width: 2999,
    height: 2999
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondJeu1);
export default __webpack_public_path__ + "static/media/fond_jeu_1.cca0094f75b47606a3b75dd51b5fe008.svg";
export { ForwardRef as ReactComponent };